import {OrderModel} from "../Models/OrderModel";
import {CategorieModel, ProductModel} from "../Models/ProductModel";
import {useEffect, useState} from "react";
import useHttpClient from "./http/useHttpClient";
import {useGetStockAvailable} from "./useGetStockAvailable";

export const useGetCrossSellingItems = (order: OrderModel | undefined): ProductModel[] => {
    const [products, setProducts] = useState<ProductModel[]>([])
    const{getProducts} = useHttpClient()
    const getStockAvailable = useGetStockAvailable()

    function shuffle(array: ProductModel[]) {
        let currentIndex = array.length,  randomIndex;

        // While there remain elements to shuffle.
        while (currentIndex !== 0) {

            // Pick a remaining element.
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }

        return array;
    }

    const isBoisson = (categories: CategorieModel[]) => {
        return categories.map(c => c.name).join("").toLowerCase().includes('boisson')
    }

    const isAlimentaire = (categories: CategorieModel[]) => {
        return categories.map(c => c.name).join("").toLowerCase().includes('alimentaire')
    }

    const isSnack = (categories: CategorieModel[]) => {
        return categories.map(c => c.name).join("").toLowerCase().includes('snack')
    }

    const filterProducts = (products: ProductModel[]) => {
        const orderProductsTypes = order?.orderProducts?.map(op => op.product).map(o => {
            if (isBoisson(o.categories ?? [])) {
                return 'boisson'
            }
            if (isAlimentaire(o.categories ?? [])) {
                return 'alimentaire'
            }
            if (isSnack(o.categories ?? [])) {
                return 'snack'
            }
            return ""
        })
        let result: ProductModel[] = shuffle(products)
        if(orderProductsTypes?.every(t => t === "boisson")) {
            const boissons: ProductModel[] =  result.filter(p => isBoisson(p.product.productCategories))
            const otherProducts: ProductModel[] = result.filter(p => !isBoisson(p.product.productCategories))
            result = [...otherProducts, ...boissons]
        } else if(orderProductsTypes?.every(t => t === "alimentaire")) {
            const alimentaires: ProductModel[] =  result.filter(p => isAlimentaire(p.product.productCategories))
            const otherProducts: ProductModel[] = result.filter(p => !isAlimentaire(p.product.productCategories))
            result = [...otherProducts, ...alimentaires]
        } else if(orderProductsTypes?.every(t => t === "snack")) {
            const snacks: ProductModel[] =  result.filter(p => isSnack(p.product.productCategories))
            const otherProducts: ProductModel[] = result.filter(p => !isSnack(p.product.productCategories))
            result = [...otherProducts, ...snacks]
        }
        result = result.filter(p => getStockAvailable(p) > 0)
            .filter(product => !order?.orderProducts?.map(op => op.product)
                .map(p => p.id)
                .includes(product.product.id))

        if(result.length > 4) {
            return result.slice(0, 4)
        }
        return result
    }

    useEffect(() => {
        const pdvId = order?.pdv?.id
        if(pdvId) {
            void getProducts(pdvId.toString()).then((r: any) => {
                setProducts(filterProducts(r))
            })
        }
    }, [order])

    return products
}
